import { GROUP_DEFAULTS, LEAF_DEFAULTS } from "./Defaults";
import { defaultListFnConfig, genId } from "./exports";

export const mkLeaf = type => ({
  id:genId(type), type,
  visible:true,
  staticText: type==="text"?"Hello World":type==="button"?"Click Me":type==="ticker"?"Breaking News...":type==="checkbox"?"Checkbox":"",
  dynamic:false, dynamicKey:"", dynamicFallback:"", dynamicTransform:"",
  inputVar:"", inputPlaceholder:"",
  onClick:[],
  // Button icon
  ...(type === "button" && {
    iconEnabled: false,
    icon: "",
    iconPosition: "left",
    iconGap: 6,
    // Special function
    specialFn: "none",       // "none" | "translate" | "speak"
    // translate params
    translateTargetLanguage: "es",
    translateSourceLanguage: "auto",
    translateMode: "screen",
    // speak params
    speakerVoice: "default",
    speakerRate: 1.0,
    speakerPitch: 1.0,
    speakerVolume: 1.0,
    speakerMode: "screen",
    speakerCustomText: "",
  }),
  // Google Map specific properties
  ...(type === "googleMap" && {
    googleMapApiKey: "",
    googleMapMarkers: [],
    googleMapSourceId: "",
    googleMapStartingLat: 40.7128,
    googleMapStartingLng: -74.0060,
    googleMapZoom: 12,
    googleMapShowInfoCard: true,
    googleMapMarkersDataKey: "",
    googleMapCenterSearch: "",
    googleMapCenterLat: null,
    googleMapCenterLng: null,
    googleMapCenterTitle: "",
    googleMapShowRoadNames: true,
    googleMapShowRivers: true,
    googleMapShowWaterBodies: true,
    googleMapShowPoi: true,
    googleMapShowTransit: true,
    googleMapShowScale: false,
    googleMapMapType: "roadmap",
    googleMapExcelData: null,
    googleMapLatColumn: "lat",
    googleMapLngColumn: "lng",
    googleMapTitleColumn: "title",
    googleMapShowRoutes: false,
    googleMapTravelMode: "DRIVING",
    googleMapRouteColor: "#6366f1",
    googleMapRouteWeight: 4,
    googleMapRouteOpacity: 0.8,
    googleMapMarkerType: "circle",
    googleMapCenterLabelText: "",
    googleMapCenterLabelBg: "#1a2228",
    googleMapCenterLabelColor: "#ffffff",
    googleMapCenterLabelBorderRadius: 20,
    googleMapCenterLabelFontSize: 12,
    googleMapCenterLabelBorderColor: "rgba(255,255,255,0.2)",
    googleMapMapTheme: "default",
    googleMapCustomMapStyles: "",
    googleMapShowMarkerLabel: false,
    googleMapMarkerLabelBg: "rgba(15,22,28,0.88)",
    googleMapMarkerLabelColor: "#ffffff",
    googleMapMarkerLabelBorderRadius: 10,
    googleMapMarkerLabelFontSize: 10,
    googleMapInfoCardFields: [],
    googleMapListFn: defaultListFnConfig(),
  }),
  // Video specific properties
  ...(type === "video" && {
    videoAutoPlay: false,
    videoControls: true,
    videoLoop: false,
    videoMuted: false,
    videoPlaysinline: true,
    videoPoster: "",
    onEnd: [],
  }),
  // YouTube specific properties
  ...(type === "youtube" && {
    youtubeAutoPlay: false,
    youtubeControls: true,
    youtubeLoop: false,
    youtubeMute: false,
    youtubeStart: 0,
    youtubeEnd: 0,
    youtubeRel: false,
    youtubeModestbranding: true,
    onEnd: [],
  }),
  ...(type === "checkbox" && {
    checkboxChecked: false,
    checkboxLabelPosition: "right",
    checkboxSize: 18,
    checkboxAccentColor: "#6366f1",
    checkboxLabelGap: 8,
    inputVar: "",
  }),
  ...(type === "divider" && {
    dividerOrientation: "horizontal",
    dividerStyle: "solid",
    dividerThickness: 2,
    dividerColor: "#36454F",
  }),
  ...(type === "table" && {
    tableColumns: [{ key: "name", label: "Name" }, { key: "value", label: "Value" }],
    tableRows: [{ name: "Row 1", value: "Data 1" }, { name: "Row 2", value: "Data 2" }, { name: "Row 3", value: "Data 3" }],
    tableHeaderBg: "#36454F",
    tableHeaderColor: "#ffffff",
    tableRowBg: "#2a363d",
    tableAltRowBg: "#222d33",
    tableRowColor: "#f0f4f5",
    tableBorderColor: "#36454F",
    tableShowHeader: true,
    tableStriped: true,
  }),
  ...(type === "slider" && {
    sliderMin: 0,
    sliderMax: 100,
    sliderStep: 1,
    sliderDefaultValue: 50,
    sliderShowValue: true,
    sliderLabel: "",
    sliderAccentColor: "#6366f1",
    inputVar: "",
  }),
  ...(type === "quiz" && {
    quizQuestions: [
      {
        question: "Sample question?",
        questionImage: "",
        answerType: "mcq",
        optionsType: "text",
        options: ["Option A", "Option B", "Option C", "Option D"],
        correct: 0,
        correctText: "",
        timeLimit: 0,
        category: "",
      }
    ],
    quizQuestionsPerPage: 1,
    quizScoreVar: "",
    quizCategory: "",
    quizShowFeedback: true,
    quizSourceId: "",
    quizOptionStyle: "card",
    quizQuestionAlign: "left",
    quizQuestionFontSize: 0,
    quizQuestionFontWeight: "600",
    quizQuestionFontFamily: "",
    quizOptionLayout: "column",
    quizOptionColumns: 2,
    quizOptionFontSize: 0,
    quizOptionFontFamily: "",
    quizOptionColor: "",
    quizOptionBg: "",
    quizOptionBorderColor: "",
    quizOptionBorderRadius: 6,
    quizQuestionMarginBottom: 10,
    quizOptionGap: 6,
    quizContainerPaddingX: 12,
    quizContainerPaddingY: 10,
    quizContentValign: "top",
    quizAutoAdvance: true,
    quizAutoAdvanceDelay: 350,
    quizTimeLimit: 0,
    quizTimerMode: "per-page",
    quizTimerColor: "#ef4444",
    quizTimerBg: "rgba(239,68,68,0.1)",
  }),
  ...(type === "model3d" && {
    model3dUrl: "",
    model3dBg: "dark",
    model3dBgColor: "#1a2228",
    model3dAutoRotate: true,
    model3dCameraControls: true,
    model3dExposure: 1,
    model3dShadowIntensity: 1,
  }),
  ...(type === "confetti" && {
    confettiCount: 60,
    confettiColors: "#ff4757,#ffa502,#2ed573,#1e90ff,#eccc68,#ff6b81,#a29bfe,#ff9ff3",
    confettiSpeed: 3,
    confettiLoop: true,
    confettiGravity: 1,
    confettiMode: "fall",
    confettiSize: 8,
  }),
  ...(type === "html" && {
    htmlCode: `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<style>
  *, *::before, *::after { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; width: 100%; height: 100%; overflow: hidden; background: #1a2228; }
  .machine-container { display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; }
  .machine { background: #2a363d; border-radius: 12px; padding: 20px; text-align: center; width: 240px; box-shadow: 0 4px 24px #0008; }
  .indicator { width: 16px; height: 16px; border-radius: 50%; display: inline-block; margin: 0 auto 10px; }
  .indicator.on  { background: #22c55e; box-shadow: 0 0 10px #22c55e88; }
  .indicator.off { background: #ef4444; }
  .screen { background: #111; border-radius: 6px; padding: 10px; margin-bottom: 12px; color: #22c55e; font-family: monospace; font-size: 14px; }
  .btn { background: #6366f1; color: #fff; border: none; border-radius: 6px; padding: 8px 24px; font-size: 13px; cursor: pointer; }
  .btn:hover { background: #818cf8; }
  .conveyor { background: #222; border-radius: 4px; height: 32px; display: flex; align-items: center; padding: 0 8px; overflow: hidden; }
  .item { width: 20px; height: 20px; background: #f59e0b; border-radius: 3px; animation: move 2s linear infinite paused; }
  @keyframes move { from { transform: translateX(0); } to { transform: translateX(220px); } }
</style>
</head>
<body>
<div class="machine-container">
  <div class="machine">
    <div class="indicator on" id="led"></div>
    <div class="screen"><p id="status">READY</p></div>
    <button class="btn" id="btn" onclick="toggle()">START</button>
    <div class="conveyor"><div class="item" id="item"></div></div>
  </div>
</div>
<script>
  var running = false;
  function toggle() {
    running = !running;
    document.getElementById('led').className = 'indicator ' + (running ? 'on' : 'off');
    document.getElementById('status').textContent = running ? 'RUNNING' : 'STOPPED';
    document.getElementById('btn').textContent = running ? 'STOP' : 'START';
    document.getElementById('item').style.animationPlayState = running ? 'running' : 'paused';
    if (typeof setKioskVar === 'function') setKioskVar('machineRunning', running);
  }
</script>
</body>
</html>`,
    htmlVarBridge: true,
    htmlScrolling: false,
  }),
  ...(type === "button" && { quizTargetId: "" }),
  ...(type === "keyboard" && {
    keyboardTheme: "dark",
    keyboardShowAlways: false,
    keyboardTarget: "",
    keyboardPanelColor: "",
    keyboardKeyColor: "",
    keyboardTextColor: "",
    keyboardEnterColor: "",
  }),
  ...((type === "carousel" || type === "productList" || type === "pdfViewer") && {
    productSource: "catalog",
    productSourceId: "",
    productSourceKey: "",
    productSelectVar: "selectedProduct",
    productFilterTags: "",
    productTagVar: "",
    productTagMatch: "all",
    productSearchVar: "",
  }),
  ...(type === "carousel" && {
    carouselMode: "marquee",
    carouselSpeed: 40,
    carouselDirection: "left",
    carouselInterval: 4,
    carouselResumeDelay: 2.5,
    carouselGap: 32,
    carouselItemWidth: 0,
    carouselImageRatio: 1.45,
    carouselItemRadius: 4,
    carouselItemShadow: true,
    carouselObjectFit: "cover",
    carouselShowTitle: false,
    carouselShowPrice: false,
    carouselShowDots: true,
    carouselTapToCenter: true,
    carouselDotColor: "",
    carouselEmptyText: "",
  }),
  ...(type === "productList" && {
    productViewMode: "listing",
    productDisplay: "selected",
    productId: "",
    productFallbackFirst: false,
    productColumns: 2,
    productGap: 20,
    productPadding: 16,
    productImageRatio: 1.45,
    productListImageWidth: 120,
    productThumbRadius: 4,
    productCardBg: "#ffffff",
    productCardRadius: 14,
    productFullCard: false,
    productTextColor: "#1f2937",
    productSubTextColor: "#6b7280",
    productAccentColor: "#d97706",
    productAccent2Color: "",
    productPriceColor: "",
    productShowPrice: true,
    productFreeLabel: "",
    productShowMeta: true,
    productShowTags: true,
    productShowTitle: false,
    productDescLines: 4,
    productLimit: 0,
    productMoreLabel: "More",
    productShowFilterChips: false,
    productFilterChipsLabel: "Showing results for",
    productEmptyText: "",
    productCtaLabel: "View",
    productCtaIcon: "",
    productCtaBg: "#ffffff",
    productCtaColor: "",
    productCtaActions: [],
    productMoreActions: [],
  }),
  ...(type === "pdfViewer" && {
    pdfSource: "url",
    pdfUrl: "",
    pdfUrlVar: "",
    pdfViewMode: "auto",
    pdfCoverAlone: true,
    pdfAllowModeToggle: true,
    pdfShowControls: true,
    pdfControlsAutoHide: 4,
    pdfFlipDuration: 650,
    pdfTapZone: 0.3,
    pdfPadding: 24,
    pdfPageBg: "#ffffff",
    pdfControlsBg: "rgba(17,24,39,0.72)",
    pdfControlsColor: "#ffffff",
    pdfQuality: 1.6,
    pdfEmptyText: "",
    pdfLoadingText: "",
  }),
  styles:{...LEAF_DEFAULTS[type]||LEAF_DEFAULTS["text"]},
});
export const mkGroup = (name="Group") => ({
  id:genId("group"), type:"group", name,
  visible:true,
  isModal:false,
  styles:{...GROUP_DEFAULTS},
  children:[],
  onClick:[],
  data:{enabled:false,mode:"static",staticType:"json",staticJSON:{},staticArray:[],sourceId:"",repeat:false,layout:"column",columns:2,rowGap:8,colGap:8,rssFeedUrl:"",rssMaxItems:20,listFn:defaultListFnConfig()},
});
export const mkScreen = (n=1) => ({
  id:genId("screen"), name:`Screen ${n}`,
  styles:{width:390,height:844,backgroundColor:"#1a2228",backgroundImage:""},
  children:[],
});

export const mkDataSource = (type = "api") => ({
  id: genId("src"),
  name: type === "rss" ? "RSS Source" : type === "googleSheets" ? "Google Sheet Source" : type === "custom" ? "Custom Source" : "API Source",
  type,
  enabled: true,
  fetchOnScreenLoad: true,
  url: "",
  method: "GET",
  responseKey: "",
  storeAs: "",
  params: [],
  pollEnabled: false,
  pollIntervalSec: 60,
  rssFeedUrl: "",
  maxItems: 20,
  sheetUrl: "",
  sheetGid: "0",
  headers: [],
  headersJSON: "",
  bodyJSON: "",
});


export const mkParamRow = () => ({ id: genId("p"), key: "", source: "literal", literalValue: "", varName: "", type: "query" });

export const mkAction = type => ({
  navigate:{id:genId("act"),type:"navigate",targetScreenId:""},
  apiCall: {id:genId("act"),type:"apiCall",name:"",sourceId:"",url:"",method:"POST",params:[],storeAs:"",responseKey:""},
  setVar:  {id:genId("act"),type:"setVar",varName:"",value:""},
  showElements:{id:genId("act"),type:"showElements",elementIds:[]},
}[type]||{id:genId("act"),type});
